import { BarChart, Bar, XAxis, YAxis, Tooltip, CartesianGrid, Cell } from 'recharts';
import { Operator, StatisticsProps } from './Statistics.props';
import { generateColor } from '../../utils/utils';
import './Statistics.scss';

// страница СТАТИСТИКА (статистика обращений)

function Statistics({ ALL, WORK, SENT_REQUEST, EXECUTE, APPOINTED }: StatisticsProps ) { 

  const renderList = (list: Operator[]) => {
    return list.map((item) => {
      return (
        <li className="statistics__list-item" key={item.OPERATOR_ID}>
          {item.NAME}: <span className="statistics__result">{item.COUNT}</span>
        </li>
      );
    });
  };

  const data = EXECUTE.map((item, index) => ({
    name: item.NAME,
    value: Number(item.COUNT),
  }));


  const atWorkList = renderList(WORK);
  const sendReqList = renderList(SENT_REQUEST);
  const completedList = renderList(EXECUTE);
  const appointedList = renderList(APPOINTED);
  const colors = generateColor(data.length);


  return (
    <div className="statistics__page-container">
      {/* <div className="statistics__wrapper">
        <div className="statistics__all">
          Количество обращений всего: <span className="statistics__result_all">{ALL.ALL_QUESTION}</span>
        </div>
        <div className="statistics__new">
          Новых: <span className="statistics__result">{ALL.NEW}</span>
        </div>
        <div className="statistics__set-request">
          Отправлен запрос: <span className="statistics__result">{ALL.SENT_REQUEST}</span>
          <ul className="statistics__list">{sendReqList}</ul>
        </div>

        <div className="statistics_appointed">
          <div className="statistics__completed">
            Выполнено за период: <span className="statistics__result">{ALL.EXECUTE}</span>
            <ul className="statistics__list">{completedList}</ul>
          </div>
          <div className="statistics__at-work">
            Обращения, назначенные в работу: <span className="statistics__result">{ALL.WORK}</span>
            <ul className="statistics__list">{atWorkList}</ul>
          </div>
        </div>
      </div> */}
      
      <div className="statistics__wrapper">
        <div className="statistics__all">
          Всего: <span className="statistics__result">{ALL.ALL_QUESTION}</span>
        </div>
        <div className="statistics__new">
          Новых: <span className="statistics__result">{ALL.NEW}</span>
        </div>
        <div className="statistics__at-work">
          В работе: <span className="statistics__result">{ALL.WORK}</span>
          <ul className="statistics__list">{atWorkList}</ul>
        </div>
        <div className="statistics__set-request">
          Отправлен запрос: <span className="statistics__result">{ALL.SENT_REQUEST}</span>
          <ul className="statistics__list">{sendReqList}</ul>
        </div>
        <div className="statistics_appointed">
          <div className="statistics__completed">
            Выполненные: <span className="statistics__result">{ALL.EXECUTE}</span>
            <ul className="statistics__list">{completedList}</ul>
          </div>
          <div className="statistics__completed">
            Всего назначено: <span className="statistics__result">{ALL.APPOINTED}</span>
            <ul className="statistics__list">{appointedList}</ul>
          </div>
        </div>
      </div>

      <div>
        <div className="statistics__completed statistics__completed_chart">
          Количество выполненных обращений:
        </div>
        <BarChart width={600} height={300} data={data}>
          <XAxis dataKey="name" angle={-85} textAnchor="end" interval={0} height={100} tick={{fontSize: 13}} />
          <Tooltip />
          <CartesianGrid stroke="#ccc" strokeDasharray="5 5" />
          <Bar dataKey="value" fill="#8884d8">
            {data.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={colors[index]} />
            ))}
          </Bar>
        </BarChart>
      </div>
    </div>
  );
}

export default Statistics;